import Verify from './Verify.vue';

Verify.install = (Vue) => {
  Vue.component(Verify.name, Verify);
};

export default Verify;
